// TODO: Find fix for eslint-disable below and remove. (Alternate component to div for badge__inner due to accessibility issues)
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

import { useClassName } from '@travpro/hooks';

const Badge = ({ badgeImg, title = '', active = false, rounded = true, lockLinkUrl = '', onClick = () => {} }) => {
  const c = useClassName('badge');


  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  if (mobile) {
    return (
      <div {...c()}>
        <div {...c('container')}>
          <div {...c('inner')} onClick={onClick}>
            <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />
          </div>

          {!active && !lockLinkUrl?.length > 0 && (
            <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
          )}

          {!active && lockLinkUrl?.length > 0 && (
            <a onClick={() => window.ReactNativeWebView.postMessage(`webview:${lockLinkUrl}`)}>
              <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
            </a>
          )}
        </div>
        {title?.length > 0 && <h3>{title}</h3>}
      </div>
    );
  }

  return (
    <div {...c()}>
      <div {...c('container')}>
        <div {...c('inner')} onClick={onClick}>
          <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />
        </div>

        {!active && !lockLinkUrl?.length > 0 && (
          <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
        )}

        {!active && lockLinkUrl?.length > 0 && (
          <a href={lockLinkUrl}>
            <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
          </a>
        )}
      </div>
      {title?.length > 0 && <h3>{title}</h3>}
    </div>
  );
};

Badge.propTypes = {
  title: PropTypes.string,
  badgeImg: PropTypes.string.isRequired,
  active: PropTypes.bool,
  rounded: PropTypes.bool,
  lockLinkUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default Badge;
